// Define ContentType enum directly to avoid Prisma client dependency issues during tests
export enum ContentType {
  PRODUCT = 'PRODUCT',
  PROJECT = 'PROJECT',
  ARTICLE = 'ARTICLE',
  LOCATION = 'LOCATION',
  SERVICE = 'SERVICE',
  NONE = 'NONE'
}

export const ContentTypeToKey: Record<ContentType, string> = {
  ARTICLE: 'articles',
  PRODUCT: 'products',
  PROJECT: 'projects',
  SERVICE: 'services',
  LOCATION: 'locations',
  NONE: 'none'
}
